<template>
  <aside ref="sidebar" class="mc-liveview--fo-sidebar">
    <div
      v-if="detailData && detailData.sequence && detailData.sequence.length"
      ref="sidebarWrapper"
      class="mc-liveview--fo-sidebar-wrapper"
    >
      <div
        v-if="isStatusEnded"
        ref="mobileSidebarActual"
        class="mc-liveview--fo-mobile-sidebar-actual"
      >
        Selesai Pada:
        {{ formatIndexDate(detailData.actual_arrival_on).date }},
        {{ formatIndexDate(detailData.actual_arrival_on).time }}
      </div>
      <div v-else ref="mobileSidebarEstimate" class="mc-liveview--fo-mobile-sidebar-estimate">
        Estimasi Selesai:
        {{ formatIndexDate(detailData.expected_arrival_on).date }},
        {{ formatIndexDate(detailData.expected_arrival_on).time }}
      </div>
      <span ref="sidebarToggle" class="mc-liveview--fo-sidebar-toggle" @click="clickToggle()">
        <i class="mc-fa icon-fill_arrow-ios-left"></i>
        <i class="mc-fa icon-fill_arrow-ios-right"></i>
      </span>
      <h4 ref="sidebarHeader" class="mc-liveview--fo-sidebar-header">
        Pelacakan Penugasan {{ detailData.number }}
      </h4>
      <div ref="sidebarBody" class="mc-liveview--fo-sidebar-body">
        <div
          ref="sidebarStatus"
          class="d-flex justify-content-center mc-liveview--fo-sidebar-status"
        >
          <McWizard :items="wizardItems" :activeKey="wizardActiveKey" :compact="true" />
        </div>
        <div class="mc-liveview--fo-sidebar-detail">
          <div
            v-if="!isStatusEnded"
            class="d-flex justify-content-between mc-liveview--fo-sidebar-detail-item mc-liveview--fo-sidebar-detail-item-current-location"
          >
            <div class="d-flex justify-content-between">
              <div class="d-flex">
                <i class="mc-fa icon-outline_live-view" />
              </div>
              <div>
                <p>Lokasi Saat Ini</p>
                <b-skeleton-wrapper :loading="isLoading">
                  <template #loading>
                    <b-skeleton />
                  </template>
                  <span class="text-muted">{{ lastPosition }}</span>
                </b-skeleton-wrapper>
              </div>
            </div>
          </div>
          <div class="justify-content-between mc-liveview--fo-sidebar-detail-item">
            <div class="d-flex" style="grid-column: 1">
              <div class="d-flex">
                <i class="mc-fa icon-fill_home" />
              </div>
              <div>
                <p>Titik Awal</p>
                <b-skeleton-wrapper :loading="isLoading">
                  <template #loading>
                    <b-skeleton />
                  </template>
                  <span class="text-muted">{{ detailData.sequence[0]?.address?.full_name }}</span>
                </b-skeleton-wrapper>
              </div>
            </div>
            <div class="text-end" style="grid-column: 2">
              <span class="text-muted">Waktu Berangkat</span>
              <b-skeleton-wrapper :loading="isLoading">
                <template #loading>
                  <b-skeleton />
                </template>
                <p class="blue-500 font-size-11">
                  {{ formatIndexDate(detailData.actual_departure_on).date }},
                  {{ formatIndexDate(detailData.actual_departure_on).time }}
                </p>
              </b-skeleton-wrapper>
            </div>
          </div>
          <div class="separator">
            <i class="mc-fa icon-outline_arrow-down" />
          </div>
          <div class="justify-content-between mc-liveview--fo-sidebar-detail-item">
            <div class="d-flex" style="grid-column: 1">
              <div class="d-flex">
                <i class="mc-fa icon-fill_home" />
              </div>
              <div>
                <p>Titik Akhir</p>
                <b-skeleton-wrapper :loading="isLoading">
                  <template #loading>
                    <b-skeleton />
                  </template>
                  <span class="text-muted">{{
                    detailData.sequence[detailData.sequence.length - 1]?.address?.full_name
                  }}</span>
                </b-skeleton-wrapper>
              </div>
            </div>
            <div v-if="isStatusEnded" class="text-end" style="grid-column: 2">
              <span class="text-muted">Waktu Selesai</span>
              <b-skeleton-wrapper :loading="isLoading">
                <template #loading>
                  <b-skeleton />
                </template>
                <p class="blue-500 font-size-11">
                  {{ formatIndexDate(detailData.actual_arrival_on).date }},
                  {{ formatIndexDate(detailData.actual_arrival_on).time }}
                </p>
              </b-skeleton-wrapper>
            </div>
            <div v-else class="text-end" style="grid-column: 2">
              <span class="text-muted">Estimasi Selesai</span>
              <b-skeleton-wrapper :loading="isLoading">
                <template #loading>
                  <b-skeleton />
                </template>
                <p class="blue-500 font-size-11">
                  {{ formatIndexDate(detailData.expected_arrival_on).date }},
                  {{ formatIndexDate(detailData.expected_arrival_on).time }}
                </p>
              </b-skeleton-wrapper>
            </div>
          </div>
        </div>

        <div class="accordion mc-liveview--fo-sidebar-accordion" role="tablist">
          <DriverInfo
            :dataDriver="dataDriver"
            :referenceNumber="detailData.shipment_reference"
            :loading="isLoading"
          />
          <ListDelivery :dataDelivery="dataDelivery" :loading="isLoading" />
          <TaskHistory :dataHistory="dataHistory" :loading="isLoading" />
        </div>
      </div>
    </div>
    <footer ref="sidebarFooter" class="mc-liveview--fo-sidebar-footer">
      <span>
        Terakhir diupdate pada :
        {{ formatIndexDate(currentDateTime).date + ' ' + formatIndexDate(currentDateTime).time }}
      </span>
      <div>
        <span
          :hidden="
            getAsset('copyrightLogo', 'general') == null ||
            getAsset('copyrightLogo', 'general') == ''
          "
          >{{ $t('global.text.poweredBy') }} :
        </span>
        <figure class="d-inline-block mb-0">
          <img
            ref="imgCopyrightLogo"
            alt
            :src="getAsset('copyrightLogo', 'general')"
            @load="handleImageLoad()"
          />
        </figure>
      </div>
    </footer>
  </aside>
</template>

<script>
import ListDelivery from './ListDelivery'
import TaskHistory from './TaskHistory'
import DriverInfo from './DriverInfo'
import McWizard from '@/components/McWizard'
import { mapGetters } from 'vuex'
import { formatIndexDate } from '@/helpers/tzDate'
import { GetAddressData } from '@/services/api/map'
import { getAddress, getGeolocation } from '@/services/api/geolocation'
import { Helper } from '@/mixin/helper'
import debounce from 'lodash'

export default {
  components: {
    ListDelivery,
    TaskHistory,
    DriverInfo,
    McWizard,
  },
  mixins: [Helper],
  props: {
    detailData: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    currentDateTime: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      dataDriver: {
        driver: null,
        vehicle: null,
        driver_2: null,
      },
      dataHistory: null,
      dataDelivery: null,
      lastPosition: '-',

      sidebarHeight: 0,
      resizeListener: null,
      isImageLoading: true,
    }
  },

  computed: {
    ...mapGetters({
      getAsset: 'asset/getAsset',
    }),
    isStatusEnded() {
      return this.detailData.status.raw_type === 'ENDED'
    },
    isLoading() {
      return this.loading || this.isImageLoading
    },
    wizardItems() {
      return [
        {
          key: 'STARTED',
          label: this.$t('fleetTask.status.started'),
        },
        {
          key: 'ENDED',
          label: this.$t('fleetTask.status.ended'),
        },
      ]
    },
    wizardActiveKey() {
      return this.detailData.status.raw_type
    },
  },

  watch: {
    detailData: {
      handler() {
        this.updateDataDriver()
        this.updateDataHistory()
        this.updateDataDelivery()
        this.updateLastPosition()
      },
      immediate: true,
      deep: true,
    },
    isLoading: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$nextTick(() => {
            this.calculateCompHeight(true)
          })
        }
      },
    },
  },

  mounted() {
    this.resizeListener = () => debounce(this.calculateCompHeight(true), 150)
    window.addEventListener('resize', this.resizeListener)
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeListener)
  },

  methods: {
    formatIndexDate,
    updateDataDriver() {
      if (this.detailData) {
        this.dataDriver = {
          driver: this.detailData.driver_user || null,
          vehicle: this.detailData.vehicle || null,
          driver_2: this.detailData.driver_user_2 || null,
        }
      }
    },
    updateDataHistory() {
      if (this.detailData) {
        this.dataHistory = this.detailData.history
      }
    },
    updateDataDelivery() {
      if (this.detailData) {
        this.dataDelivery = this.detailData.delivery_order
      }
    },
    async updateLastPosition() {
      if (this.detailData?.vehicle?.last_postion) {
        const useCache = this.isUsingCache()
        const lat = this.detailData?.vehicle?.last_postion?.latitude ?? null
        const lon = this.detailData?.vehicle?.last_postion?.longitude ?? null

        if (useCache) {
          const address = await getGeolocation({ lat, lon })
          this.lastPosition = getAddress(address, lat, lon)?.name
        } else {
          const address = await GetAddressData(lat, lon)
          this.lastPosition = address.display_name
        }
      }
    },
    clickToggle() {
      const sidebar = this.$refs.sidebarBody
      const isFullMap = document.body.classList.contains('mc-full-map')
      document.body.classList.toggle('mc-full-map')

      if (window.innerWidth >= 890) return

      if (sidebar && isFullMap) {
        this.$nextTick(() => {
          sidebar.scrollTo({ top: 0 })
          this.calculateModalHeight(true)
        })
      } else {
        this.clearSidebarStyle()
      }
    },
    calculateCompHeight(resize = false) {
      if (window.innerWidth >= 890) {
        this.clearSidebarStyle()
        const mapWrapper = document.getElementById('livetrack-map')
        const sidebarWrapper = this.$refs.sidebarWrapper
        if (mapWrapper && sidebarWrapper) {
          mapWrapper.style.height = ''
          sidebarWrapper.style.height = ''
        }
        return
      }

      if (resize) {
        const sidebarEl = this.$refs.sidebarBody
        if (sidebarEl) {
          sidebarEl.scrollTo({ top: 0 })
        }
      }

      this.calculateModalHeight()
      this.calculateMapHeight()
    },
    calculateMapHeight() {
      const mapWrapper = document.getElementById('livetrack-map')

      if (mapWrapper) {
        mapWrapper.style.height = `calc(100vh - ${this.sidebarHeight}px)`
      }
    },
    calculateModalHeight(withAnimation = false) {
      const isFullMap = document.body.classList.contains('mc-full-map')
      const sidebarTime = this.$refs.mobileSidebarEstimate || this.$refs.mobileSidebarActual
      const sidebarToggle = this.$refs.sidebarToggle
      const sidebarHeader = this.$refs.sidebarHeader
      const sidebarStatus = this.$refs.sidebarStatus
      const sidebarFooter = this.$refs.sidebarFooter
      const sidebar = this.$refs.sidebar
      const sidebarWrapper = this.$refs.sidebarWrapper

      let sidebarHeight
      if (
        sidebarTime &&
        sidebarToggle &&
        sidebarHeader &&
        sidebarStatus &&
        sidebarFooter &&
        !isFullMap
      ) {
        sidebarHeight =
          sidebarTime.offsetHeight +
          sidebarToggle.offsetHeight +
          sidebarHeader.offsetHeight +
          sidebarStatus.offsetHeight +
          32 +
          sidebarFooter.offsetHeight
      }

      if (sidebar && sidebarWrapper) {
        if (!withAnimation) {
          sidebar.style.transition = 'none'
        }

        sidebarWrapper.style.height = `calc(100% - ${sidebarFooter.offsetHeight}px)`

        if (sidebarHeight) {
          this.sidebarHeight = sidebarHeight
          sidebar.style.height = `${sidebarHeight}px`
          sidebar.style.top = `calc(100% - ${sidebarHeight}px)`
        }

        if (!withAnimation) {
          sidebar.style.transition = ''
        }
      }
    },
    clearSidebarStyle() {
      const sidebar = this.$refs.sidebar
      if (sidebar) {
        sidebar.style.height = ''
        sidebar.style.top = ''
      }
    },
    handleImageLoad() {
      this.isImageLoading = false
    },
  },
}
</script>
